<template lang="pug">
  div
    button.btn.btn-facebook.btn-block(type="button" @click.prevent="loginWithFacebook" v-if="!$wait.is('facebook logging in')")
      slot(name="buttonText") {{ trans('labels.frontend.auth.login_with_facebook') }}
    button.btn.btn-facebook.btn-block(v-if="$wait.is('facebook logging in')" disabled="disabled")
      font-awesome-icon(:icon=['far', 'circle-notch'] spin class="mr-2")
      | {{ trans('labels.frontend.auth.logging_in') }}
</template>

<script>
import notify from '../../notify';

export default {
  methods: {
    async loginWithFacebook() {
      this.$wait.start('facebook logging in');
      const self = this;

      await this.$auth.authenticate('facebook').then(async (response) => {
        console.log(response);
        try {
          await self.$store.dispatch('auth/loginWithSocial', response);
        } catch (e) {
          notify.errors(this, e);
        }
      }).catch((err) => {
        notify.errors(this, err);
      });
      this.$wait.end('facebook logging in');
    },
  },
};
</script>
